import { render, staticRenderFns } from "./mxdigittag.vue?vue&type=template&id=83d04e54&scoped=true"
import script from "./mxdigittag.vue?vue&type=script&lang=js"
export * from "./mxdigittag.vue?vue&type=script&lang=js"
import style0 from "./mxdigittag.vue?vue&type=style&index=0&id=83d04e54&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d04e54",
  null
  
)

export default component.exports